module.exports = __webpack_public_path__ + "img/shield-check.15b139f3.svg";